import { ThemeColorInterface } from './';

export const PurpleTheme: ThemeColorInterface[] = [
    { key: '--rgb-main-background-color', value: '29, 14, 56' },
    { key: '--rgb-body-background-color', value: '41, 23, 86' },
    { key: '--rgb-header-background-color', value: '41, 23, 86' },
    { key: '--rgb-subheader-background-color', value: '51, 27, 103' },
    { key: '--rgb-dropdown-background-color', value: '94, 58, 167' },
    { key: '--rgb-icons', value: '198, 186, 241' },
    { key: '--rgb-primary-cta-color', value: '138, 94, 232' },
    { key: '--rgb-contrast-cta-color', value: '247, 242, 254' },
    { key: '--rgb-secondary-contrast-cta-color', value: '198, 186, 241' },
    { key: '--rgb-cta-layer-color', value: '255, 255, 255' },
    { key: '--rgb-system-green', value: '84, 180, 137' },
    { key: '--rgb-system-red', value: '232, 94, 89' },
    { key: '--rgb-system-yellow', value: '232, 175, 89' },
    { key: '--rgb-asks', value: '232, 94, 89' },
    { key: '--rgb-bids', value: '84, 180, 137' },
    { key: '--rgb-primary-text-color', value: '248, 247, 250' },
    { key: '--rgb-text-contrast-color', value: '186, 108, 249' },
    { key: '--rgb-input-background-color', value: '41, 23, 86' },
    { key: '--rgb-divider-color', value: '165, 141, 221' },
    { key: '--rgb-shadow-color', value: '29, 14, 56' },
    { key: '--rgb-landing-background-color', value: '251, 251, 251' },
    { key: '--rgb-strength-meter-very-strong', value: '108, 239, 239' },
];
